export interface DataEntity_Resolution_07_Interface {
    id: number,
    capacity:string,
    unit:string,
    scale:string,

  }
  
  export function Empty_DataEntity_Resolution_07_Interface(): DataEntity_Resolution_07_Interface {
    return {
      id: 0,
      capacity:'',
      unit:'',
      scale: '',

    }
  }
  